const basePath = '/files';

export const filesRoutes = {
  root: basePath,
  explorer: `${basePath}/explorer`,
  details: `${basePath}/details/:fileId`,
  shared: `${basePath}/shared`,
} as const;
